module.exports = __webpack_public_path__ + "/assets/img/icon_link400ba167.svg";